import './ComparisonSpecifications.css';const comparisonSpecifications__specGroupLabel = "_comparisonSpecifications__specGroupLabel_1yd4u_1";
const comparisonSpecifications__specGroupValue = "_comparisonSpecifications__specGroupValue_1yd4u_10";
const comparisonSpecifications__header = "_comparisonSpecifications__header_1yd4u_19";
const comparisonSpecifications__title = "_comparisonSpecifications__title_1yd4u_22";
const comparisonSpecifications__row = "_comparisonSpecifications__row_1yd4u_39";
const styles = {
  comparisonSpecifications__specGroupLabel,
  comparisonSpecifications__specGroupValue,
  comparisonSpecifications__header,
  comparisonSpecifications__title,
  comparisonSpecifications__row
};
export {
  comparisonSpecifications__header,
  comparisonSpecifications__row,
  comparisonSpecifications__specGroupLabel,
  comparisonSpecifications__specGroupValue,
  comparisonSpecifications__title,
  styles as default
};
